import OverlayTrigger from 'react-bootstrap/esm/OverlayTrigger'
import '../styles.css'
import { Button, Col, Container, Popover, Row } from 'react-bootstrap'
import { IEstimateFee } from '../../model/naglog/IEstimateFee'
import { useState, useEffect } from 'react'
import { IPath } from '../../model/ahamove/UrlRequestParam'
import Loading from '../../utilities/Loading'
import moment from 'moment'

export default function EstimateFeeComponent(props: IEstimateFee) {

  let _deliveryPointNum = props.data_view.length - 1
  const getIntendTime = (timeSecond: number) => {
    var tempTime = moment.duration(timeSecond, 'seconds')
    let stringTime = ''
    stringTime += (tempTime.days() > 0) ? `${tempTime.days()} ngày ` : ''
    stringTime += (tempTime.hours() > 0) ? `${tempTime.hours()} giờ ` : ''
    stringTime += (tempTime.minutes() > 0) ? `${tempTime.minutes()} phút` : ''
    return stringTime
  }

  const [dataView, setDataView] = useState<IPath[]>([...props.data_view])
  const [showCls, setshowCls] = useState(props.show ? 'd-block' : 'd-none')

  const [isShowOverlay, setIsShowOverlay] = useState(false)
  const handleSetOverlayStatus = (state: boolean)=>{
    setIsShowOverlay(state)
  }
  useEffect(() => {
    setDataView(props.data_view)
    setshowCls(props.show ? 'd-block' : 'd-none')
    setIsShowOverlay(false)
  }, [props])
  const dataPathTmp = () => {
    return dataView.map((item, index) => {
      // sender
      if (index === 0) {
        let senderTmp = (
          <div key={index} className='row align-items-center' >
            <label className='text-nowrap col-auto'><i className='bi bi-arrow-down-square-fill text-danger fs-6'></i></label>
            <div className='m-1 col'><p className='fw-semibold m-0'>{item.address}</p></div>
          </div>
        )
        return senderTmp
      } else {
        let receiverTmp = (
          <div key={item.level} className='row align-items-center'>
            <label className='text-nowrap col-auto'><i className='bi bi-box-seam-fill text-success fs-6'></i></label>
            <div className='m-1 col'><p className='fw-semibold m-0'>{item.address}</p></div>
          </div>
        )
        return receiverTmp
      }
    })
  }

  return (
    <div className={showCls}>
      {props.fetch_data?.is_loading ? (
        <Loading></Loading>
      ) : (
        <>
          {/* route */}
          <div className='row align-items-center' >
            <label className='text-nowrap col-2'>lộ trình</label>
            <div className='m-1 col'><p className='fw-semibold m-0'>{_deliveryPointNum} điểm giao ~ {props.fetch_data?.distance} km</p></div>
          </div>
          <div className='row align-items-center' >
            <label className='text-nowrap col-2'>thời gian dự kiến</label>
            <div className='m-1 col'><p className='fw-semibold m-0'>{getIntendTime(props.fetch_data?.duration ?? 0)}</p></div>
          </div>


          {/* pick up */}
          {dataPathTmp()}

          {/* payment fees */}
          <div className='row align-items-center'>
            <label className='text-nowrap col-2'>phí giao hàng</label>
            <div className='m-1 col'><p className='fw-semibold m-0'>{`${props.fetch_data?.distance_price} ${props.fetch_data?.currency}`}</p></div>

          </div>
          {/* total payment */}
          <div className='row align-items-center'>
            <label className='text-nowrap col-2 fs5 fw-semibold m-0'>tổng thanh toán</label>
            <div className='m-1 col'>
              <p className='fw-semibold m-0'>{`${props.fetch_data?.total_price} ${props.fetch_data?.currency}`}
                <OverlayTrigger trigger='click' placement='right' show={isShowOverlay} overlay={
                  <Popover id='popover-basic' className='w-100'>
                    <Popover.Body>
                      <Container className='p-0'>
                        <Row><h6>chi tiết giao hàng</h6></Row>
                        <Row>
                          <Col sm={7}>phí giao hàng</Col>
                          <Col sm={5}>xxx VND</Col>
                        </Row>
                        <Row>
                          <Col sm={7}>phí yêu cầu đặc biệt</Col>
                          <Col sm={5}>xxx VND</Col>
                        </Row>
                        <hr />
                        <Row>
                          <Col sm={7}><h6>tổng thanh toán</h6></Col>
                          <Col sm={5}><i className='bi bi-coin text-warning'></i> xxx VND</Col>
                        </Row>
                        <Row className='justify-content-sm-left'>
                          <Col sm='auto'>
                            <Button type='button' variant='light' size='sm' onClick={()=>handleSetOverlayStatus(false)}>close</Button>
                          </Col>
                        </Row>
                      </Container>
                    </Popover.Body>
                  </Popover>
                }>
                  <i className='bi bi-info-circle mx-1' onClick={()=>handleSetOverlayStatus(true)}></i>
                </OverlayTrigger>
              </p>
            </div>
          </div>
        </>
      )
      }
    </div>
  )
}